/**
 * @license
 * @copyright Copyright Motili Inc., 2025 All Rights Reserved
 */

/* eslint-disable no-console */

import * as Sentry from '@sentry/react';

import Config from '../../Config';

export function log(...args) {
    return info(...args);
}

export function info(...args) {
    if (Config.environment === 'local' || Config.environment === 'dev') {
        console.log(...args);
    }
}

export function warn(...args) {
    console.warn(...args);
}

export function error(...args) {
    const skipSentryIndex = args.findIndex(
        arg =>
            arg?.skipSentry &&
            typeof arg === 'object' &&
            !Array.isArray(arg) &&
            !(arg instanceof Error)
    );
    const errorArgs = args.filter((_, index) => index !== skipSentryIndex);

    console.error(...errorArgs);

    if (skipSentryIndex !== -1) return;

    Sentry.withScope(scope => {
        const additionalContext = [];
        let errorObj = null;

        errorArgs.forEach(arg => {
            if (arg instanceof Error) {
                errorObj = arg;
            } else if (arg && typeof arg === 'object' && arg.stack) {
                scope.setExtra('componentStack', arg.stack);
            } else {
                additionalContext.push(arg);
            }
        });

        if (errorObj) {
            if (additionalContext.length > 0) {
                scope.setContext('additionalArguments', additionalContext);
            }
            Sentry.captureException(errorObj);
        } else {
            Sentry.captureMessage(JSON.stringify(errorArgs));
        }
    });
}
